import { doc, updateDoc, serverTimestamp, arrayUnion } from 'firebase/firestore';
import { db } from './firebase-init';

/**
 * Start production on a job
 * @param {string} jobId - The job document ID
 * @param {string} shopWorkerName - Name of the shop worker starting production
 * @returns {Promise<{success: boolean}>}
 */
export async function startProduction(jobId, shopWorkerName) {
  try {
    const jobRef = doc(db, 'jobs', jobId);
    const now = new Date(); // ✅ Use JavaScript Date for arrayUnion

    await updateDoc(jobRef, {
      status: 'in_production',
      startedBy: shopWorkerName,
      productionStartedBy: shopWorkerName,
      productionStartedAt: serverTimestamp(), // ✅ serverTimestamp OK here
      updatedAt: serverTimestamp(), // ✅ serverTimestamp OK here
      statusHistory: arrayUnion({
        status: 'in_production',
        timestamp: now, // ✅ FIXED: Use new Date() instead of serverTimestamp()
        note: `Production started by ${shopWorkerName}`,
        shopWorkerName: shopWorkerName,
        action: 'production_started' // ✅ Added for Cloud Function recognition
      })
    });

    return { success: true };
    
  } catch (error) {
    console.error('❌ Error starting production:', error);
    throw error;
  }
}